module.exports = __webpack_public_path__ + "static/media/gamesPlayed_100000_250000.0319ed79.png";